module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "toc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfront"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00_fm04_pre#ch00_fm04_pre"
    }
  }, [_vm._v("A Preface in Three Parts")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00_fm04_pre#ch00_fm04_preseclev1"
    }
  }, [_vm._v("Economics as a Razor")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00_fm04_pre#ch00_fm04_preseclev2"
    }
  }, [_vm._v("Conservative and Anti-conservative")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00_fm04_pre#ch00_fm04_preseclev3"
    }
  }, [_vm._v("A Note on the Vocabulary of Color")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_c('strong', [_vm._v("1 The Color of Prosperity: A Few Facts about Black Economic Well-Being in America")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01sec1lev1"
    }
  }, [_vm._v("Color and Well-Being in America")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01sec2lev1"
    }
  }, [_vm._v("Two Black Americas")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01sec1lev2"
    }
  }, [_vm._v("“Merit,” Economic Change, and the Racial Blame Game")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01sec2lev2"
    }
  }, [_vm._v("Genes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01sec2lev3"
    }
  }, [_vm._v("Culture")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01sec1lev3"
    }
  }, [_vm._v("Conservatives and the “Culture of Poverty”")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01sec1lev4"
    }
  }, [_vm._v("Taking Society Seriously")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01sec1lev5"
    }
  }, [_vm._v("Next Steps")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2 Race and the Market")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02sec1lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capitalism and the Political Economy of Color")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02sec1lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discrimination in Market Society: Insights from Economists")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02sec2lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Becker")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02sec2lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Race and Crime in Capitalism: A Complication")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02sec2lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Economic Logic and “Legacies”")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02sec2lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Uncertainty, Merit, and Discrimination")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02sec1lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Overcoming Racial Inequality: The Conservative Stance")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02sec1lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beyond Race: Capitalism, Individualism, and Family Meltdown")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02sec1lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Social Capital and Black Self-Help")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02sec1lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About Dynamics and the Color of Political Economy")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02sec1lev7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: Discrimination and Human Capital in a Dynamic Becker Model")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02sec2lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Learning-by-Doing and the Legacy of Discrimination")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02sec2lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("System I: Dynamics of Labor Efficiency in an Open, Racially Divided Economy")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3 Confusion and Woe: Race, Capitalism, and the Retreat from Social Justice in America")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03sec1lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Race and Macroeconomics")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03sec1lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Productivity")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03sec1lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Productivity Arithmetic")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03sec1lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Economics of Liberal Racial Reform")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03sec2lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Race and the Breakdown of the New Deal")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03sec1lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Budget Deficits and Racial Reform")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03sec2lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Budget Deficits: A Primer")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03sec2lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deficits and Exchange Rates")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03sec2lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deficits, Globalism, and the End of Racial Reform")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03sec1lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Race, Welfare, and the “Modern Class Conflict”")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03sec2lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Merit and Social Regard")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03sec1lev7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Race and Markets Kill Social Decency: A Restatement")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03sec1lev8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conservatives and the American Dilemma")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03sec2lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Race and the Strategy of Inequality")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03sec2lev7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trouble for White Labor")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03sec2lev8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Politics and the Strategy of Inequality")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03sec1lev9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: The “Rule of 70”")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4 The Political Economy of Hope and Fear")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04sec1lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Predicament")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04sec1lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Black and Blue and Very Scared")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04sec2lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Adversity and Opportunity")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04sec1lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On Race, Poverty, and Prisons")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04sec2lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Color, Class, and Crime")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04sec2lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Social Costs and Benefits of Punishment")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04sec2lev7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prison Math")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04sec1lev8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Choice")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04sec2lev9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Quixotic, though Plausible, Egalitarian Program")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04sec2lev10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jobs and Wage Subsidies")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04sec2lev11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Long Run")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04sec2lev12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The End of Prohibition, Again")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04sec1lev13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Next Black Rebellion")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbackt"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/note#note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/works#works",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Works Cited")])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/author#author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f815db4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm03_con.vue
// module id = 66
// module chunks = 0